export default {
  id: "beyond-books-ice-age",
  pride: 15360,
  slug: "beyond-books-ice-age",
  series: "beyond-books",
  category: ["game", "ai"],
  status: "development",
  experienceable: true,
  titleKey: {
    zh: "不止于纸上的故事：冰河篇",
    en: "Beyond Books: Ice Age"
  },
  image: "https://img.itch.zone/aW1nLzE4OTE4ODQ4LnBuZw==/315x250%23c/BgThd5.png",
  descriptionKey: {
    zh: "末世生存恋爱游戏。十二年前方格神用熵减炮轰击地球，将世界变成充满结晶的废墟。你是冬眠中心的幸存者，不知为何躲过了这场浩劫。第一个 Demo 刚出来，流程约半分钟，开发中。",
    en: "Apocalyptic survival romance. Twelve years ago, the Square God fired an entropy-reduction cannon at Earth, leaving the world as crystalline ruins where matter spontaneously becomes more ordered. You're a cryosleep survivor who somehow made it through. First demo out, ~30 seconds of content, in development."
  },
  genres: ["互动叙事", "恋爱", "末世生存"],
  themes: ["熵减", "结晶废土", "冰河末世"],
  platform: ["Web"],
  developerNotesKey: {
    zh: "不止于纸上的故事系列新篇。末世生存恋爱为主，但感兴趣的内容都会做。世界观特色：熵减炮打破了热力学第二定律，物质自发趋向有序，冰晶废土独特世界感。",
    en: "A new arc in the Beyond Books series. Primarily apocalyptic survival romance, but open to wherever interest leads. World hook: the entropy-reduction cannon breaks the second law of thermodynamics — matter spontaneously becomes more ordered, creating a uniquely crystalline wasteland."
  },
  tags: ["不止于纸上"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "itch", url: "https://tobenot.itch.io/beyond-books-ice-age", textKey: { zh: "itch.io 游玩 Demo", en: "Play Demo on itch.io" } }
  ]
};
